import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteUserModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.user, e)}
            title="Delete User?"
            confirmText="Yes, Delete User"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following User?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-4">Name</th>
                        <th className="col-xs-4">Username</th>
                        <th className="col-xs-4">Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.user.firstName} {props.user.surname}</td>
                        <td>{props.user.username}</td>
                        <td>{props.user.email}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}